/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import moment from 'moment'
import { DEFAULT_LANGUAGE, DEBUG_LANGUAGE } from 'constants/localization'
import { getTexts } from 'api/client/actions/languages'
import {
  getLang,
  // getLoadedTextsUpdated,
  getCurrentTexts,
} from 'redux-app/selectors/localization'
import { createModuleAction, handlePromiseActions } from 'redux-app/utils/reducer'
import { mergeTexts } from 'redux-app/utils/localization'
import { loadingWrapper } from 'redux-app/utils/loadingWrapper'
import { ILocalizationState } from 'redux-app/types/localization'

const createAction = createModuleAction('LOCALIZATION')

const setLanguageLocal = createAction('SET_LANGUAGE')
export const updateLocalTexts = createAction('UPDATE_LOCAL_TEXTS')

export const setLanguage = code => (dispatch, getState) => {
  const state = getState()
  const lang = getLang(state)
  const isLangChanged = lang !== code

  dispatch(setLanguageLocal({
    lang: code,
  }))

  if (code === DEBUG_LANGUAGE) {
    const debugTexts = Object.keys(getCurrentTexts(state)).reduce((acc, key) => ({
      ...acc,
      [key]: key,
    }), {})
    dispatch(updateLocalTexts(debugTexts))
    return
  }

  dispatch(onLoadTexts(isLangChanged))
}

export const onLoadTexts = isLangChanged => (dispatch, getState) => {
  const state = getState()
  const lang = getLang(state)
  // const updated = !isLangChanged
  //   ? getLoadedTextsUpdated(state)
  //   : null

  moment.locale(lang)
  return Promise.all([
    // commented while no i18n
    // dispatch(getTexts({ code: lang, updated })),
    import(`localization/${lang}.json`),
  ])
    .then(([module]) => {
      dispatch(updateLocalTexts(module.default))
    })
    .catch(() => {
      // dispatch(updateLocalTexts({}))
      console.warn(`No texts for ${lang}`)
    })
}

const ACTION_HANDLERS = {
  [setLanguageLocal.toString()]: (state: ILocalizationState, { payload: { lang } }) => ({
    ...state,
    lang,
  }),
  [getTexts.toString()]: loadingWrapper('loadedTexts', [
    null,
    (state: ILocalizationState, { payload: { result: response } }, value = {}) => {
      if (!response || response.length === 0) {
        return value
      }
      const { metadata, payload } = response[0] || {}

      return {
        meta: {
          ...value.meta,
          ...metadata,
        },
        texts: mergeTexts(value.texts, payload),
      }
    },
    null,
  ]),
  [updateLocalTexts.toString()]: (state: ILocalizationState, { payload }) => {
    return {
      ...state,
      localTexts: payload,
    }
  },
}

const initialState: ILocalizationState = {
  lang: DEFAULT_LANGUAGE,
  localTexts: {},
  loadedTexts: {
    value: {},
  },
  links: {
    value: {},
  },
}

export default handlePromiseActions(ACTION_HANDLERS, initialState)
